import { render, staticRenderFns } from "./ScreenshotPreview.vue?vue&type=template&id=0871551d&scoped=true"
import script from "./ScreenshotPreview.vue?vue&type=script&lang=js"
export * from "./ScreenshotPreview.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotPreview.vue?vue&type=style&index=0&id=0871551d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871551d",
  null
  
)

export default component.exports